// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__3oIPf","text":"Divider_text__Q-azh"};